import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { institutionsProgramIdSelectors } from '@ucheba/store/institutions/programs/programId'
import { IUseRotationBannerAndAdmissionInstructions } from './types'
import { usePaidPackage } from '../../bll/usePaidPackage'

const randomInt = Math.floor(Math.random() * 2)

export const useRotationBannerAndAdmissionInstructions =
  (): IUseRotationBannerAndAdmissionInstructions => {
    const program = useSelector(institutionsProgramIdSelectors.entity)

    const hasPaidPackage = usePaidPackage()

    const hasAdmissionInstruction = useMemo(
      () =>
        !!(
          program?.faculty?.admissionInstruction ||
          program?.institution?.admissionInstruction
        ),
      [program]
    )

    const admissionInstruction =
      program?.faculty?.admissionInstruction || program?.institution?.admissionInstruction

    const institutionId = useMemo(
      () => program?.faculty?.id || program?.institution?.id,
      [program]
    )

    const programTypes = useMemo(
      () =>
        program?.programType?.value
          ? {
              'programTypes[]': [program?.programType?.value],
            }
          : undefined,
      [program]
    )

    const [showAdmissionInstruction, setShowAdmissionInstruction] =
      useState<boolean>(true)

    useEffect(() => {
      if (hasAdmissionInstruction && hasPaidPackage) {
        setShowAdmissionInstruction(true)
      } else if (hasAdmissionInstruction && !hasPaidPackage) {
        setShowAdmissionInstruction(randomInt !== 1)
      } else {
        setShowAdmissionInstruction(false)
      }
    }, [])

    return {
      showAdmissionInstruction,
      hasPaidPackage,
      institutionId,
      admissionInstruction,
      programTypes,
    }
  }
